// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3faOI","icon":"SortAdornment_icon__B6uQ-","up":"SortAdornment_up__3mTGo","down":"SortAdornment_down__34_YB","active":"SortAdornment_active__3H_qZ"};